export function initSiteHeader() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const body = document.body;

    const burger = header.querySelector('[data-burger]');
    const overlay = header.querySelector('[data-header-overlay]');
    const menu = header.querySelector('[data-mobile-menu]');
    const close = header.querySelector('[data-mobile-close]');

    const desktopNavList = header.querySelector('[data-header-nav-list]');
    const mobileMenuList = header.querySelector('[data-mobile-menu-list]');

    const desktopCta = header.querySelector('[data-header-cta]');
    const mobileCtaWrap = header.querySelector('[data-mobile-cta]');

    const desktopLangLinks = header.querySelectorAll('[data-lang-option]');
    const mobileLangs = header.querySelector('[data-mobile-langs]');

    const lang = header.querySelector('[data-lang]');
    const langToggle = header.querySelector('[data-lang-toggle]');

    const desktopBreakpoint = 1100;
    let menuCloseTimer = null;

    const buildMobileMenu = () => {
        if (!desktopNavList || !mobileMenuList) return;

        mobileMenuList.innerHTML = '';

        desktopNavList.querySelectorAll('a').forEach((link) => {
            const item = document.createElement('li');
            const clonedLink = link.cloneNode(true);

            clonedLink.className = 'mobile-menu__link';
            clonedLink.removeAttribute('id');

            item.appendChild(clonedLink);
            mobileMenuList.appendChild(item);
        });
    };

    const buildMobileCta = () => {
        if (!desktopCta || !mobileCtaWrap) return;

        mobileCtaWrap.innerHTML = '';

        const clonedCta = desktopCta.cloneNode(true);

        clonedCta.className = 'btn btn--block mobile-menu__cta';
        clonedCta.removeAttribute('id');
        clonedCta.removeAttribute('data-header-cta');

        mobileCtaWrap.appendChild(clonedCta);
    };

    const buildMobileLangs = () => {
        if (!desktopLangLinks.length || !mobileLangs) return;

        mobileLangs.innerHTML = '';

        desktopLangLinks.forEach((link) => {
            const clonedLang = link.cloneNode(true);

            clonedLang.className = 'mobile-menu__lang';

            if (link.classList.contains('is-active')) {
                clonedLang.classList.add('is-active');
            }

            clonedLang.removeAttribute('id');
            clonedLang.removeAttribute('data-lang-option');

            mobileLangs.appendChild(clonedLang);
        });
    };

    const closeLang = () => {
        if (!lang || !langToggle) return;

        lang.classList.remove('is-open');
        langToggle.setAttribute('aria-expanded', 'false');
    };

    const toggleLang = () => {
        if (!lang || !langToggle) return;

        const shouldOpen = !lang.classList.contains('is-open');

        lang.classList.toggle('is-open', shouldOpen);
        langToggle.setAttribute('aria-expanded', String(shouldOpen));
    };

    const openMenu = () => {
        if (!burger || !menu || !overlay) return;

        clearTimeout(menuCloseTimer);
        closeLang();

        header.classList.add('is-menu-open');
        body.classList.add('is-lock');

        menu.hidden = false;
        overlay.hidden = false;

        burger.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                menu.classList.add('is-open');
                overlay.classList.add('is-active');
            });
        });
    };

    const closeMenu = () => {
        if (!burger || !menu || !overlay) return;

        clearTimeout(menuCloseTimer);

        header.classList.remove('is-menu-open');
        body.classList.remove('is-lock');

        menu.classList.remove('is-open');
        overlay.classList.remove('is-active');

        burger.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');

        menuCloseTimer = setTimeout(() => {
            if (!menu.classList.contains('is-open')) {
                menu.hidden = true;
                overlay.hidden = true;
            }
        }, 380);
    };

    const toggleMenu = () => {
        header.classList.contains('is-menu-open') ? closeMenu() : openMenu();
    };

    const onScroll = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
    };

    buildMobileMenu();
    buildMobileCta();
    buildMobileLangs();

    menu?.classList.remove('is-open');
    overlay?.classList.remove('is-active');

    if (menu) {
        menu.hidden = true;
        menu.setAttribute('aria-hidden', 'true');
    }

    if (overlay) {
        overlay.hidden = true;
    }

    burger?.setAttribute('aria-expanded', 'false');

    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });

    burger?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        toggleMenu();
    });

    close?.addEventListener('click', (event) => {
        event.preventDefault();

        closeMenu();
    });

    overlay?.addEventListener('click', closeMenu);

    menu?.addEventListener('click', (event) => {
        const link = event.target.closest('a');

        if (link) {
            closeMenu();
        }
    });

    langToggle?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        toggleLang();
    });

    document.addEventListener('click', (event) => {
        if (lang && !lang.contains(event.target)) {
            closeLang();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeMenu();
            closeLang();
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth >= desktopBreakpoint) {
            closeMenu();
        }
    });
}